export class ApiActionError extends Error {
  publicDetail: string;

  constructor(apiError: unknown, publicDetail: string) {
    super(typeof apiError === 'string' ? apiError : JSON.stringify(apiError));
    this.name = 'ApiActionError';
    this.publicDetail = publicDetail;
  }
}

/**
 * Arma el detalle visible a partir del cuerpo de error de la API: el código, el
 * mensaje cuando es seguro mostrarlo y, cuando el CP lo provee, el logId con el
 * que se puede recuperar el error completo de los logs del servidor.
 */
export function buildPublicErrorDetail(apiError: any): string {
  const code = apiError?.code ?? apiError?.error?.code;
  const logId = apiError?.logId ?? apiError?.error?.customData?.logId;
  const message = apiError?.message ?? apiError?.error?.message;
  const status = apiError?.status ?? apiError?.statusCode;

  const parts: string[] = [];

  if (code) {
    parts.push(`Código de error: ${code}.`);
  }

  if (message && !logId && typeof status === 'number' && status < 500) {
    parts.push(message);
  }

  if (logId) {
    parts.push(`Identificador del error: ${logId}`);
  }

  return parts.join(' ');
}

export function apiActionError(apiError: unknown): ApiActionError {
  return new ApiActionError(apiError, buildPublicErrorDetail(apiError));
}
